import { render } from "./page-search.vue?vue&type=template&id=b578f55a&scoped=true&ts=true"
import script from "./page-search.vue?vue&type=script&lang=ts"
export * from "./page-search.vue?vue&type=script&lang=ts"

import "./page-search.vue?vue&type=style&index=0&id=b578f55a&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b578f55a"]])

export default __exports__